"use client";

import { useTranslations } from "next-intl";
import React from "react";

import ContactForm from "../ContactForm/ContactForm";

const LeadFormWrapper = React.memo(() => {
  const t = useTranslations();

  return (
    <div className="h-full flex flex-col px-m md:pt-s md:p-0 md:justify-center md:items-end">
      <div className="md:w-[70%] md:mr-[40px] flex flex-col gap-m md:gap-m rtl:md:mr-0 rtl:md:ml-[40px]">
        <div className="flex flex-col mb-s">
          <p className="font-normal uppercase font-primary text-l mb-s">{t("label.common.expertise")}</p>
          <p className="font-secondary font-secondary-light text-m">{t("label.common.expertiseDes")}</p>
        </div>
        {/* <h2 className="font-primary font-medium text-m uppercase text-black-0">{t(`getInTouch.modal.title`)}</h2>
        <p className="mb-l font-secondary text-black-0">{t(`getInTouch.modal.subtitle`)}</p> */}
        <ContactForm leadFormPageLocation="" blackTheme={true} />
      </div>
    </div>
  );
});

LeadFormWrapper.displayName = "LeadFormWrapper";

export default LeadFormWrapper;
